import { Dispatch, SetStateAction } from 'react';
import { PencilRuler } from 'lucide-react';
import { Button } from 'primereact/button';
import { ChallengePhase } from '../../components/AssessmentComponent/AssessmentComponent';
import RetakeCountdownBar from './RetakeCountdownBar';
import { useCooldown } from '../../contexts/RetakeCountdownContext';
import { usePreviewMode } from '../../contexts/PreviewModeContext';
import { requestFullscreen } from '../../utils/fullscreen';

interface Props {
  skillCode: string;
  setAssessmentInProgress: Dispatch<SetStateAction<boolean>>;
  setSkipNewActivityId: Dispatch<SetStateAction<boolean>>;
  setDisabledReviewModal: Dispatch<SetStateAction<boolean>>;
  refetchLrnSession: () => void;
  setPhase: Dispatch<SetStateAction<ChallengePhase>>;
}

const RetakeCountdownWrapperUI: React.FC<Props> = ({
  skillCode,
  setAssessmentInProgress,
  setSkipNewActivityId,
  setDisabledReviewModal,
  refetchLrnSession,
  setPhase,
}) => {
  const ctx = useCooldown();
  const remainingDone = ctx?.remainingDone(skillCode);
  const previewMode = usePreviewMode();

  // The cooldown finishing is a timer event, not a user gesture, so browsers block
  // requestFullscreen() if we auto-advance here. Instead we wait for the student to
  // click a button, which gives us the transient activation fullscreen requires.
  const handleReadyClick = () => {
    if (!previewMode) {
      requestFullscreen();
    }
    setSkipNewActivityId(false);
    setDisabledReviewModal(true);
    setAssessmentInProgress(true);
    refetchLrnSession();
    setPhase('PRE');
  };

  return (
    <div className="tw-flex tw-flex-col tw-h-full">
      <div className="tw-flex tw-flex-row tw-p-6 tw-items-center">
        <PencilRuler />
        <span className="sm:tw-text-2xl tw-text-lg tw-font-sora tw-font-bold tw-ml-4">Skill Challenge</span>
      </div>
      <div className="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-pb-14">
        <div className="tw-w-full tw-max-w-[420px] tw-px-6">
          <RetakeCountdownBar skillCode={skillCode} width="100%" />
          {remainingDone && (
            <div className="tw-flex tw-flex-col tw-items-center">
              <Button className="tw-font-atkinson tw-mt-2" label="Ready to try again!" onClick={handleReadyClick} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RetakeCountdownWrapperUI;
